/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11\" height=\"11\"><path fill-rule=\"evenodd\" d=\"M6 5V0H5v5H0v1h5v5h1V6h5V5H6z\"/></svg>\n";
//# sourceMappingURL=plus.svg.js.map